import React, { useState } from "react";

import { addresses, abis } from "@my-app/contracts";
import {
  Body,
  Button,
  Container,
  Image,
  DivFlex,
  DivSecret,
  LabelSecret,
  InputSecret,
  DivStatus,
  Title,
  BottomText,
  PriceText,
  Link,
  LinkLogoContainer,
  LinkLogo,
} from "./components";
import logo from "./assets/images/87.png";
import githubLogo from "./assets/images/GitHub-Mark-120px-plus.png";
import openseaLogo from "./assets/images/Logomark-Blue.png";

let Contract = require("web3-eth-contract");

const amountToMint = 1;
const priceInEth = 0.5;
const apiURL = "https://nft-api.flyingnobita.workers.dev";
const supportedChainId = [4, 1337];

const MintButton = () => {
  let mintInProgress = false;

  const [contract, setContract] = useState(null);
  const [buttonText, setButtonText] = useState("");
  const [account, setAccount] = useState("");
  const [secret, setSecret] = useState("");
  const [saleLive, setSaleLive] = useState(true);
  const [status, setStatus] = useState("");
  const [numberMinted, setNumberMinted] = useState(0);

  const Web3 = require("web3");
  const web3 = new Web3(Web3.givenProvider || "ws://localhost:8545");

  const changeButtonText = React.useCallback(() => {
    let text = "CONNECT WALLET";
    if (!saleLive) {
      text = "SALE ENDED";
    } else {
      if (account) {
        text = "MINT";
      }
    }
    setButtonText(text);
  }, [saleLive, account]);

  React.useEffect(() => {
    changeButtonText();
  }, [changeButtonText]);

  const showStatus = (inputStatus) => {
    setStatus(inputStatus);
  };

  async function connect() {
    showStatus("");
    const chainId = await web3.eth.getChainId();
    if (supportedChainId.indexOf(chainId) === -1) {
      showStatus("Only Rinkeby is supported");
      return;
    }
    if (typeof window.ethereum !== "undefined") {
      await window.ethereum.request({ method: "eth_requestAccounts" });
      Contract.setProvider(window.ethereum);
      const kanjiContract = new Contract(abis.kanji, addresses.kanji);
      setContract(kanjiContract);
      const resSaleLive = await kanjiContract.methods.saleLive.call().call();
      setSaleLive(resSaleLive);

      const numberMinted = await kanjiContract.methods.totalSupply
        .call()
        .call();
      setNumberMinted(numberMinted);
    }

    const accounts = await web3.eth.getAccounts();
    setAccount(accounts[0]);
  }

  async function mint() {
    if (mintInProgress) return;
    showStatus("minting...");

    // test apiURL
    // const result = await fetch(apiURL).then((res) => res.json());
    // console.log("result: ", result);

    if (!secret) {
      showStatus("Secret missing!");
      return;
    }

    let transaction;
    try {
      mintInProgress = true;
      const value = new web3.utils.BN(
        web3.utils.toWei(priceInEth.toString(), "ether")
      )
        .muln(Number(amountToMint.toString()))
        .toString();

      transaction = {
        from: account,
        value,
      };

      let method;

      const fetchUrl = apiURL + `/verify/${account}/${amountToMint}/${secret}`;

      const { success, message, nonce, signature } = await fetch(fetchUrl).then(
        (res) => res.json()
      );
      if (!success) {
        showStatus(`Verification Error: ${message}`);
        return;
      }

      // console.log("success: ", success);
      // console.log("message: ", message);
      // console.log("nonce: ", nonce);
      // console.log("signature: ", signature);

      method = contract.methods["purchase"](amountToMint, signature, nonce);

      let gas = Math.floor(
        parseInt(
          await method.estimateGas({
            from: account,
            value,
          })
        ) * 1.2
      );

      showStatus("Waiting for transaction to confirm...", "pending");
      transaction = await method.send({
        from: account,
        value,
        gas,
        maxFeePerGas: null,
        maxPriorityFeePerGas: null,
      });

      if (transaction.status) {
        showStatus("Successfully purchased!", "success");
      }
    } catch (err) {
      // console.log("err: ", err);
      // console.log("err.name: ", err.name);
      // console.log("err.code: ", err.code);
      // console.log("err.message: ", err.message);
      // console.log("err.data: ", err.data);
      // console.log("typeof(err.message): ", typeof err.message);

      if (!err.message) {
        if (
          err.data.message.includes(
            "Error: VM Exception while processing transaction"
          )
        ) {
          try {
            // await method.estimateGas(transaction);
            showStatus("Unknown error. Please try again.");
          } catch (err2) {
            if (err2.message.includes("Kanji:")) {
              showStatus(err2.message);
            }
          }
        } else {
          showStatus(err);
        }
      } else if (err.message.includes("Kanji: ")) {
        const innerErrorMsg = err.message.split("\n")[3];
        var contractError = innerErrorMsg.split("Kanji: ").pop();
        contractError = contractError.substring(0, contractError.length - 2);

        showStatus(contractError);
      } else if (
        err.message ===
        "MetaMask Tx Signature: User denied transaction signature."
      ) {
        showStatus("You cancelled the transaction");
      } else if (err.message.includes("execution reverted: ")) {
        showStatus(
          err.message
            .split("execution reverted: ")[1]
            .replace(/"/g, "\n")
            .split("\n")[0]
        );
      } else if (err.message.includes("insufficient funds")) {
        showStatus("Insufficient funds");
      } else if (err.message.includes("[object Object]")) {
      } else {
        showStatus(err.message);
      }
    } finally {
      mintInProgress = false;
    }
  }

  async function handleButtonClick() {
    if (saleLive) {
      if (account) {
        mint();
      } else {
        connect();
      }
    }
  }

  let numberMintedElement;
  if (account) {
    numberMintedElement = <PriceText>Minted - {numberMinted}/ 80</PriceText>;
  }

  let secretElement;
  if (saleLive && account) {
    secretElement = (
      <DivSecret>
        <LabelSecret>SECRET</LabelSecret>
        <InputSecret
          value={secret}
          onInput={(e) => setSecret(e.target.value)}
        />
      </DivSecret>
    );
  }

  let viewYourCollectionElement;
  if (account) {
    viewYourCollectionElement = (
      <DivFlex>
        <Link href={"https://testnets.opensea.io/" + account}>
          View Your Kanji in OpenSea
        </Link>
      </DivFlex>
    );
  }

  return (
    <div>
      {numberMintedElement}
      {secretElement}
      <DivFlex>
        <Button onClick={handleButtonClick}>{buttonText} </Button>
      </DivFlex>
      <DivStatus>{status}</DivStatus>
      {viewYourCollectionElement}
    </div>
  );
};

function App() {
  return (
    <Container>
      {/* <Header></Header> */}
      <Body>
        <Title>Mint AI Generated Kanji NFTs with ECDSA</Title>
        <Image src={logo} alt="kanji" />
        <PriceText>Price - {priceInEth} ETH</PriceText>
        <MintButton />
        <BottomText>
          <Link href="https://jansonmak.com/minting-nfts-with-ecdsa-signatures">
            (blog post)
          </Link>
          <p>
            Secrets are the 80 most common pinyins{" "}
            <Link href="https://www.google.com/search?q=most+common+chinese+words+pinyin&rlz=1C1GCEA_enHK998HK998&oq=most+common+&aqs=chrome.1.69i57j69i59j0i512l8.4421j0j7">
              (hint)
            </Link>
          </p>
          <p>
            Kanji generated from{" "}
            <Link href="https://github.com/hardmaru/sketch-rnn">
              sketch-rnn
            </Link>
          </p>
        </BottomText>
        <LinkLogoContainer>
          <Link href="https://github.com/flyingnobita/nft-kanji-solidity/tree/url">
            <LinkLogo src={githubLogo} alt="github" />
          </Link>
          <Link href="https://testnets.opensea.io/collection/kanji-v3">
            <LinkLogo src={openseaLogo} alt="opensea" />
          </Link>
        </LinkLogoContainer>
      </Body>
    </Container>
  );
}

export default App;
